module.exports = __webpack_public_path__ + "OnePlus_5.svg?df44a63386c6ac5623145c2fe0368a49";


//////////////////
// WEBPACK FOOTER
// ./src/assets/devices/OnePlus_5.svg
// module id = 202
// module chunks = 0